'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { useLayoutStore } from '@/stores/layout';
export function useSearchShortcut() {
  const $ = _c(3);
  const toggleSearch = useLayoutStore(_temp);
  let t0;
  let t1;
  if ($[0] !== toggleSearch) {
    t0 = () => {
      const handleKeyDown = function handleKeyDown(event) {
        if ((event.metaKey || event.ctrlKey) && event.key === "k") {
          event.preventDefault();
          toggleSearch();
        }
      };
      document.addEventListener("keydown", handleKeyDown);
      return () => {
        document.removeEventListener("keydown", handleKeyDown);
      };
    };
    t1 = [toggleSearch];
    $[0] = toggleSearch;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
}
function _temp(state) {
  return state.toggleSearch;
}